import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import useCheckScreenSize from "../../../utils/checkScreenSize";
import { Box } from "@mui/material";
import { ItemList } from "../../../types/user-data";
import "../../styles.css";
import classNames from "classnames";
import { useState } from "react";
import { INITIAL_DATA_ADD_ITEM } from "../../../configs/initial-data";
import { BootstrapDialogTitle } from "../../../utils/common-function";
import { useTranslation } from "react-i18next";

export interface Props {
  addItemPopupFields: (fields: Partial<ItemList>) => void;
  ItemListData: ItemList[];
}

export const AddItemPopup: React.FC<Props> = ({
  addItemPopupFields,
  ItemListData,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const [addItemRowData, SetAddItemRowData] = useState(INITIAL_DATA_ADD_ITEM);
  const [submitted, setSubmitted] = useState(false);
  const isMobile = useCheckScreenSize({ breakpoint: 850 });

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    SetAddItemRowData(INITIAL_DATA_ADD_ITEM);
  };

  const addFormData = (fields: any) => {
    SetAddItemRowData((prev: any) => {
      return { ...prev, ...fields };
    });
  };
  const handleSubmitPopup = (addItemRowData: any) => {
    setOpen(false);
    addItemPopupFields(addItemRowData);
    SetAddItemRowData(INITIAL_DATA_ADD_ITEM);
  };
  const handleSubmit = () => {    
    if ( !addItemRowData.amount )
    {
      let amountError:any=document.getElementById('Amount');
      amountError.tabindex=0;
      amountError.focus();
    }
    else if ( !addItemRowData.description )
    {
      let descError:any=document.getElementById('Description');
      descError.tabindex=0;
      descError.focus();
    }
    else{
      let makeError:any=document.getElementById('Make');
      makeError.tabindex=0;
      makeError.focus();
    }
    setSubmitted(true);   
    if (
      addItemRowData.amount &&
      addItemRowData.description &&
      !(Number.parseFloat(addItemRowData.amount!) > 10000000) &&
      !(addItemRowData.amount?.toString().split(".")[1]?.length! > 2)
    ) {
      handleSubmitPopup(addItemRowData);
      setSubmitted(false);
    }
  };
  return (
    <div>
      <input
        type="button"
        onClick={handleClickOpen}
        className={classNames({
          disableButton: ItemListData.length >= 10,
          blueButton: ItemListData.length < 10,
        })}
        value= {String(t('AddItem'))}
        disabled={ItemListData.length >= 10}
      />
      <Dialog
        maxWidth={"md"}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            m: "auto",
            width: "fit-content",
          }}
          className={classNames({ popup: !isMobile })}
        >
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={handleClose}
          >
            <h2 className="subheader">{t('AddItem')}</h2>
            <div>{t('RequiredField')}</div>
          </BootstrapDialogTitle>

          <DialogContent>
            <div className="formLabelPopoup">
              <label htmlFor="Make">{t('MakeBrand')}</label>
            </div>
            <input
              id="Make"
              maxLength={20}
              className={classNames(
                { popupInputMobileItem: isMobile },
                "input"
              )}
              value={addItemRowData.make}
              onChange={(e) =>
                addFormData({
                  make: e.target.value
                    .trimStart()
                    .replaceAll(/[-~`!^;|\\":<>?()@$*{}+=]/gi, ""),
                })
              }
            />
            <div className="formLabelPopoup">
              <label htmlFor="Model">{t('Model')}</label>
            </div>
            <input
              id="Model"
              maxLength={20}
              className={classNames(
                { popupInputMobileItem: isMobile },
                "input"
              )}
              value={addItemRowData.model}
              onChange={(e) =>
                addFormData({
                  model: e.target.value
                    .trimStart()
                    .replaceAll(/[-~`!^;|\\":<>?()@$*{}+=]/gi, ""),
                })
              }
            />
            <div className={classNames({ row: !isMobile })}>
              <div className={classNames({ twoFields: !isMobile })}>
                <div className="formLabelPopoup">
                  <label htmlFor="Year">{t('Year')}</label>
                </div>
                <input
                  id="Year"
                  className={classNames(
                    {
                      popupInputHalf: !isMobile,
                      popupInputMobileItem: isMobile,
                    },
                    "input"
                  )}
                  maxLength={20}
                  value={addItemRowData.age}
                  onChange={(e) => addFormData({ age: e.target.value })}
                />
              </div>
              <div>
                <div className="formLabelPopoup">
                  <label htmlFor="Amount">{t('Amount')}</label>
                </div>
                <div className="input-icon">
                  <input
                    className={classNames(
                      "adornedInputPopup",
                      !addItemRowData.amount && submitted && isMobile
                        ? "errorpopupInputMobileItem"
                        : "inputpopupInputMobileItem",
                      !addItemRowData.amount && submitted && !isMobile
                        ? "errorpopupInputHalf"
                        : "popupInputHalf",
                      Number.parseFloat(addItemRowData.amount!) > 10000000 ||
                        addItemRowData.amount?.toString().split(".")[1]
                          ?.length! > 2
                        ? "errorpopupInputHalf"
                        : "popupInputHalf"
                    )}
                    id="Amount"
                    maxLength={11}
                    onChange={(e) => {
                      addFormData({
                        amount: e.target.value.replaceAll(/[^0-9.]/gi, ""),
                      });
                    }}                    
                    aria-describedby="Amount_error"
                    value={addItemRowData.amount}
                  />
                  <i>$</i>
                </div>

                {!addItemRowData.amount && submitted ? (
                  <div className="errorText" id="Amount_error">
                    {t('ErrorAmountRequired')}
                  </div>
                ) : null}
                {(Number.parseFloat(addItemRowData.amount!) > 10000000 ||
                  addItemRowData.amount?.toString().split(".")[1]?.length! >
                    2) && (
                  <div className="errorText" id="Amount_error" role="alert" style={{ width: "150px" }}>
                    {t('ErrorInvalidAmountEntry')}
                  </div>
                )}
              </div>
            </div>

            <div style={{ marginBottom: "10px" }}>
              <div className="formLabelPopoup">
                <label htmlFor="Description">{t('ItemDescription')}</label>
              </div>

              <textarea
                id="Description"
                className={classNames(
                  !addItemRowData.description && submitted
                    ? "errorTextarea"
                    : "textarea",
                  !addItemRowData.description &&
                    submitted &&
                    isMobile &&
                    "popupInputMobileItem",

                  isMobile && "popupInputMobileItem"
                )}
                rows={6}
                cols={37}
                maxLength={100}
                onChange={(e) => {
                  addFormData({
                    description: e.target.value
                      .trimStart()
                      .replaceAll(/[-~`!^;|\\":<>?()@$*{}+=]/gi, ""),
                  });
                }}
                value={addItemRowData.description}
                aria-describedby="Description_error"
              />
              {!addItemRowData.description && submitted ? (
                <div className="errorText" id="Description_error">
                  {t('ErrorItemDescriptionRequired')}
                </div>
              ) : null}
            </div>
            <div style={{ marginTop: "10px" }}>
              <button
                className={classNames(
                  { popupInputMobileItem: isMobile },
                  "yellowButton"
                )}
                onClick={handleSubmit}
              >
                {t('Submit')}
              </button>
            </div>
            <div className="secondButtonDiv">
              <button onClick={handleClose} className="secondButton">
                {t('Cancel')}
              </button>
            </div>
          </DialogContent>
        </Box>
      </Dialog>
    </div>
  );
};